// extracted by mini-css-extract-plugin
module.exports = {"user":"MemberRow_user__1I6HnAC_MadTHFx4od3zRm","userName":"MemberRow_userName__1x1__AqIEvO80yCYlcKLCE","groupImage":"MemberRow_groupImage__3E2debpL6Ix1orz76Qvjx5"};